import { render } from "./VLotList.vue?vue&type=template&id=8c8e0c62&scoped=true"
import script from "./VLotList.vue?vue&type=script&lang=js"
export * from "./VLotList.vue?vue&type=script&lang=js"

import "./VLotList.vue?vue&type=style&index=0&id=8c8e0c62&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8e0c62"]])

export default __exports__